import React, {useEffect, useState} from "react";
import {ValidatedForm, ValidatedInput} from "../../components/forms";
import {useDispatch, useSelector} from "react-redux";
import {userActions} from "../../redux-modules/UserModule";
import Header from "../../components/prospect-scheduling/contact-page/Header";
import BottomContent from "../../components/prospect-scheduling/contact-page/BottomContent";
import ServiceHubspotForm from "../../components/service-scheduling/ServiceHubspotForm";

export default function AuthenticationPage() {
    const [state, setState] = useState({email: "", accessCode: "", isTestMode: false});
    const dispatch = useDispatch();
    const user = useSelector(state => state.user);

    useEffect(() => {
        dispatch(userActions.setLoginPage());

        if (process.env.REACT_APP_USE_TEST_ACCESS_CODE === "true") {
            let testEmail = process.env.REACT_APP_TEST_EMAIL;
            let testCode = process.env.REACT_APP_TEST_ACCESS_CODE;
            setState({email: testEmail, accessCode: testCode, isTestMode: true});
        }
    }, []);

    useEffect(() => {
        if (user.challengeSent && process.env.REACT_APP_USE_TEST_ACCESS_CODE === "true")
            handleAccessCodeSubmit();
    }, [user.challengeSent])

    const handleAccessCodeSubmit = () => {
        dispatch(userActions.authResponse(state.email, state.accessCode));
    }
    const handleChange = (e) => {
        setState(prevState => ({...prevState, [e.target.name]: e.target.value}));
    }
    const handleEmailSubmit = () => {
        dispatch(userActions.authChallenge(state.email))
    }
    const handleBackClick = () => {
        dispatch(userActions.resetAuth());
    }
    
    let trobleshootingTips = {
        headerText: "Troubleshooting Tips",
        subText: "",
        accordionItems: [
            {
                headerText: "Why is my collar blinking red?",
                iconUrl: "",
                bodyText: "If you have started to see a red flashing light on your pet’s Computer Collar unit, your Power Cap battery may need to be replaced. You can <a href=\"https://www.invisiblefence.com/shop/batteries\">order replacement batteries online</a>, from your local dealer, or by calling <a href=\"tel:18005783647\">(800) 578-3647</a>"
            },
            {
                headerText: "Why is my control panel beeping?",
                iconUrl: "",
                bodyText: "If your Invisible Fence control panel is beeping every second, the most likely issue is that you have a wire break somewhere on your property. These can be caused by digging too deep when working in the yard, burrowing animals, and even the weather. The most important thing to know is that your fence will NOT contain your pets when there is a wire break, so you should not let your pets outside until the issue is resolved. To set up a service call for a wire break, call <a href=\"tel:18005783647\">(800) 578-3647</a> or request a service appointment from your local dealer online by submitting the form above.<br><br>If your Invisible Fence control panel is beeping with a lengthy pause between each beep, it’s possible your backup battery unit needs to be replaced. Your fence will still work, but if your power goes out, the system will no longer be operational until power is restored. You can purchase replacements through your local dealer by calling <a href=\"tel:18005783647\">(800) 578-3647</a>."
            },
            {
                headerText: "The transmitter in my basement/garage is beeping. What's wrong?",
                iconUrl: "",
                bodyText: "It’s possible you have a wire break or multiple breaks. Request a service appointment online by submitting the form above, or call us at <a href=\"tel:18005783647\">(800) 578-3647</a>. At your service appointment, our Certified Technician will test your entire system including the control panel, lightning and surge protection, Computer Collar receiver, and underground wire. We will provide a complete system analysis, make any necessary repairs, and reintroduce your pet to the Invisible Fence system."
            },
            {
                headerText: "My pet's collar doesn't activate at the boundary. What is wrong?",
                iconUrl: "",
                bodyText: "Ensure that your pet’s Computer Collar receiver is fitted properly to his neck. The collar should be snug enough to slide only one finger between a correction post and your pet’s skin. Remember to adjust the fit of the collar as your pet’s coat, weight, and age change. Your pet’s coat may change from season to season.<br><br>Make sure you’re testing the collar at the same height level as your pet. If you’re holding the collar at your waist and you have a small dog or cat, you may not hear the tone or feel the correction because you’re above the signal field. If you have a Boundary Plus® system, you’ll also want to make sure you walk through the boundary, as the correction does not occur until your pet leaves the yard.<br><br>Check your Power Cap battery. We recommend changing the battery every 3 months. Using a fresh, genuine Invisible Fence Power Cap battery is the safest, easiest and most reliable way to guarantee your pet’s safety 100% of the time. You can <a href=\"https://www.invisiblefence.com/shop/batteries\">purchase Power Cap batteries online</a> or from your local dealer.<br><br>You might have one or more wire breaks. Request a service appointment online by submitting the form above, contact your local dealer, or call us at <a href=\"tel:18005783647\">(800) 578-3647.</a> At your service appointment, our Certified Technician will test your entire system including the control panel, lightning and surge protection, Computer Collar receiver, and underground wire. We will provide a complete system analysis, make any necessary repairs, and reintroduce your pet to the Invisible Fence system."
            },
            {
                headerText: "How can I fix a wire break?",
                iconUrl: "",
                bodyText: "Request a service appointment online by submitting the form above or by calling us at <a href=\"tel:18005783647\">(800) 578-3647</a>. At your service appointment, our Technician will test your entire system including the control panel, lightning and surge protection, Computer Collar Receivers, indoor units, and underground wire. We will provide a complete system analysis and make any necessary repairs to your Invisible Fence system."
            },
            {
                headerText: "How do I add a new pet to my existing system?",
                iconUrl: "",
                bodyText: "Contact us at <a href=\"tel:18005783647\">(800) 578-3647</a> to purchase another Computer Collar unit and a Power Cap battery plan. We will also assist you in scheduling a professional trainer to come to your home, work with your new pet, and re-flag your property. <a href=\"https://www.invisiblefence.com/add-a-pet\">Click here to visit our Add a Pet page to learn more</a>."
            },
            {
                headerText: "Can I take my system with me when I move?",
                iconUrl: "",
                bodyText: "Yes! Bring your Invisible Fence transmitter and Computer Collar receiver with you to your new home and contact us at <a href=\"tel:18005783647\">(800) 578-3647</a> to install new boundary wire, flag your property and re-train your pet(s) to their new boundaries.<br><br><a href=\"https://www.invisiblefence.com/customer-resources#section-id-form\">To request a service appointment online, click here.</a>"
            },
            {
                headerText: "I purchased a house that already has an Invisible Fence® Brand system installed. How do I use it?",
                iconUrl: "",
                bodyText: "Give us a call at <a href=\"tel:18005783647\">(800) 578-3647</a> to request a service appointment and we’ll perform a system check to ensure all components are operating properly. We can also mark the boundary and assist you in training your pet(s) to the system."
            },
            {
                headerText: "My pet passed away. Can I use the same collar on a new pet?",
                iconUrl: "",
                bodyText: "Yes, however the Computer Collar receiver should be re-programmed by one of our Professional Pet Trainers so that the correction level is just right (not too high or too low) for your new pet. We also recommend scheduling a training session(s) to teach your new pet the boundaries of their Invisible Fence system. Call us at <a href=\"tel:18005783647\">(800) 578-3647</a> to schedule a session with one of our certified Perfect Start Plus Pet Trainers."
            }
            
        ]
    }
    
    return (
        <div>
            <Header imageSrc="images/service-scheduling/self-scheduler-hero.jpg"
                    imageAltText="Current Customer Scheduling Portal"
                    primaryBannerText="Current Customer Scheduling Portal"
                    secondaryBannerText=""
            />
            <div className="container contact-body-container">
                <div className="row mx-3" tabIndex="0">
                    <div className="col-12 col-md-6">
                        { !user.challengeSent && (
                            <div className="px-4">
                                <div className="row">
                                    <div className="col-sm">
                                        <p>Please enter the email address associated with your account to schedule a new appointment or reschedule an existing one.</p>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12">
                                        <ValidatedForm id="IFBSchedulerEmailForm" onSubmit={handleEmailSubmit}>
                                            <ValidatedInput id="email" name="email" type="email" value={state.email}
                                                            onChange={handleChange} validation={{presence: true}} customError={user.error}/>
                                            <button className="btn btn-primary" type="submit">Next</button>
                                        </ValidatedForm>
                                    </div>
                                </div>
                                {user.showContactFormSubmitted && (
                                    <div className="row">
                                        <div className="col-sm">
                                            <p>Thank you! You have successfully submitted your information. Someone will be in touch with you shortly.</p>
                                        </div>
                                    </div>
                                )}
                                {user.showContactForm && (
                                    <div className="row pt-4">
                                        <div className="col-12">
                                            <ServiceHubspotForm />
                                        </div>
                                    </div>
                                )}
                            </div>
                        )
                        }
                        {
                            user.challengeSent && (
                                <div className="" tabIndex="0">
                                    <div className="row">
                                        <div className="col-sm">
                                            <p>We sent a code to {state.email}</p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-6">
                                            <ValidatedForm id="IFBSchedulerAccessCodeForm" onSubmit={handleAccessCodeSubmit}>
                                                <ValidatedInput id="code" label="Access Code" name="accessCode" value={state.accessCode}
                                                                onChange={handleChange} validation={{presence: true}}
                                                                customError={user.error}/>
                                                <button className="btn btn-primary" type="submit">Next</button>
                                            </ValidatedForm>
                                        </div>
                                    </div>
                                    {state.isTestMode &&
                                        <div className="row mt-2">
                                            <div className="col-sm text-red">
                                                <p>Running in Test mode, please enter this access code: {state.accessCode}</p>
                                            </div>
                                        </div>
                                    }
                                    <div className="row mt-2">
                                        <div className="col-sm">
                                            <p>No code? Check the email above, if it's correct check your spam folder.</p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-6">
                                            <p className="scheduler-link" onClick={handleBackClick}>Go Back</p>
                                        </div>
                                        <div className="col-6">
                                            <p className="scheduler-link" onClick={handleEmailSubmit}>Resend Code</p>
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                    </div>
                    <div className="col-12 col-md-6">
                        <h3><strong>What types of appointments can I schedule?</strong></h3>
                        <ul>
                            <li>Fence Service Call</li>
                            <li>Doorman Service Call</li>
                            <li>Pet System Training</li>
                        </ul>
                        <b>Interested in a new Invisible Fence Brand System?  <a className="click-link" href="https://www.invisiblefence.com/free-consultation">Click here</a> to schedule a free consultation</b>                        
                    </div>
                </div>
                <div className="pt-4">
                    <BottomContent headerText={trobleshootingTips.headerText}
                                   subText={trobleshootingTips.subText}
                                   accordionItems={trobleshootingTips.accordionItems}
                    />
                </div>
            </div>
        </div>
    )
}
